var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVsLogoLightRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.2 136.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#c20000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M213.03,87.6c-5.73-1.59-11.17-3-11.17-6.29,0-5.84,16.67-15.19,23.93-15.99,.74-.06,1.47-.11,2.1-.11,2.15,0,3.69,.51,3.4,2.32-.74,5.16-11.79,11.51-14.12,11.51-.34,0-.68,0-.68-.34,0-.79,.34-1.98,1.19-2.95-1.13,.68-3.35,3.12-3.35,5.44,0,1.25,1.7,1.7,2.83,1.7,6.01,0,15.87-7.31,15.99-14.06,.06-4.37-3.4-5.61-8.56-5.44-8.28,.28-26.59,7.88-26.59,17.41,0,4.99,7.71,6.01,14.51,7.88,5.56,1.53,10.26,3.63,10.26,7.14,0,8.56-27.67,22.22-41.33,22.22-1.81,0-4.76-.06-4.76-2.27,0-4.2,14.4-16.73,29.42-20.81-7.31-.17-32.94,13.38-32.94,21.77,0,4.48,5.44,5.56,9.18,5.56,15.48,0,43.71-12.13,43.71-24.55,0-6.29-6.63-8.39-13.04-10.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,86.8c.68-.96,3.29-3.29,4.25-3.69,.62-.28,1.08-.06,1.19-.06,.23,0-.11-.85-.62-1.42-.74-.85-1.98-1.98-3.29-1.81-1.47,.45-3.63,4.14-3.57,5.78,.06,1.02,1.25,2.21,2.04,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,86.52c-4.99,0-13.15,4.25-14.06,8.56-.15,.73,.04,1.43,.39,2.06-4.06,3.78-10.05,9.16-12.99,9.96,.11-2.66,8.9-14.63,10.32-15.76,.74-.62-1.08-3.69-2.44-3.69-1.93,0-11.91,7.65-18.26,13.89-1.19,1.13-2.27,2.27-2.89,3.17,.85-1.59,3.8-5.78,6.46-9.3,1.7-2.21,3.8-4.59,4.54-4.54,.45,.06,.68,.34,.68,.11,0-1.42-2.15-3.63-3.57-3.63-.17,0-.51,.06-.74,.28-1.47,1.13-3.97,4.14-6.01,7.03-1.87,2.61-4.03,5.95-5.39,8.62-.11,.21-.2,.39-.3,.58-1.06,.35-2.13,.73-3.19,1.12l3.46-6.41c.96-1.93,1.25-1.76,1.42-1.59,.23-.68-2.15-3.74-3.23-3.23-.96,.45-1.81,1.3-5.73,4.59-1.87,1.59-4.54,3.69-7.26,5.5-2.49,1.64-4.76,3.12-4.99,2.89-.57-.45,3.57-7.43,8.96-12.02,3.74-3.12,7.82-5.5,11.11-5.67,1.7-.11,2.78,.74,2.78,2.44,0,.85-.34,1.53-.57,2.04-.06,.06,0,.11,.11,.06,.51-.74,1.08-1.7,1.08-2.66,0-2.66-2.83-3.57-5.05-3.57-7.52,0-16.45,6.65-20.78,12.66-3.57,3.21-7.62,6.5-9.78,7.07,.68-2.32,8.45-15.25,10.77-15.02,.45,.06,.74,.34,.74,.11,0-1.42-2.27-3.69-3.57-3.69-.23,0-.57,.06-.85,.34-3.63,2.89-11.85,15.25-11.85,18.54,0,1.02,1.42,2.44,2.32,2.72,.28,.06,.45,.06,.68,.06,2.01-.16,5.82-3.25,9.63-6.86-.46,1.05-.72,2.04-.72,2.9,0,1.13,1.42,3.17,2.44,3.8,.17,.11,.45,.17,.57,.17,1.19,0,4.54-2.44,7.77-4.93,3.17-2.49,6.29-5.27,7.14-6.07,1.08-.96,2.49-1.98,2.44-1.93,0,0-4.76,8.56-6.01,10.72-13.04,6.24-24.21,15.42-26.48,22.62-.28,.85-.4,1.59-.4,2.21,0,2.38,1.76,3.35,3.86,3.35,.62,0,1.25-.06,1.87-.23,10.89-2.89,20.24-17.12,27.5-29.76,1.12-.47,2.27-.96,3.42-1.45-.81,1.76-.99,2.83-.89,3.15,.45,1.64,1.81,3.46,3.52,3.06-.85-.4-.45-1.93,1.08-3.74,.62-.79,1.3-1.64,2.04-2.38,4.2-4.54,12.53-11.4,17.18-13.49-2.95,2.66-9.52,12.13-9.52,15.36,0,.62,.4,1.47,1.02,2.21,.57,.68,1.19,1.19,1.76,1.19,2.92,0,10.13-6.88,15.24-12.24,.91,1.2,2.16,2.01,2.53,2.48,.12,.16,.33,.75,.33,.92,0,2.58-7.03,5.94-9.24,6.57,.1-.1,4.53-4.79,4.84-5.12,.37-.35,.52-.9-.66,.1-.29,.24-5.63,3.93-5.66,5.64-.15,2.17,.91,2.27,2.15,2.27,3.69,0,11.17-3,11.96-6.69,.17-1.19-1.22-2.89-1.88-3.55-.17-.23-.52-.49-.77-.71-.57-.51-1.78-1.29-1.55-2.25,.74-2.66,9.52-8.05,12.13-7.82-.11,1.13-3.91,5.1-4.08,5.1-.06,0,.06,.23,.11,.23,1.53,0,5.1-3.4,5.16-4.2,.17-1.64-.57-4.25-2.15-4.25Zm-74.6,45.24c-.91,.45-1.87,.79-2.66,.79-.74,0-1.25-.28-1.25-1.08,0-.57,.28-1.36,.91-2.49,3.97-7.37,11.85-13.83,22.17-19.28-5.78,9.35-12.53,18.48-19.16,22.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.18,89.6c.04,.39,.05,.78,.01,1.12-.03,.37-.82,1.31-1.82,2.21,22.76-3.96,47.48-9.61,51.76-12.76,.3-.45-24,5.38-49.95,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.82,99.31c-86.78-.08-155.72-8.89-156.35-18.7-.08-1.33,1.08-2.47,3.27-3.8C8.92,77.77-.05,82.86,0,86.98c.57,15.54,101.46,19.79,158.22,18.85,5.92-.09,12.06-.26,18.34-.5,3.22-2.26,6.89-4.39,10.42-6.12-5.19,.07-10.57,.1-16.16,.09Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.65 1 55.1 41.95 59.65 1 31.32 1 24.04 76.76 62.26 76.76 106.97 1 78.65 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,1l-6.6,19.23,6.03,.68-32.99,55.85h28.44l4.25-6.82h15.88v6.82h28.55L163.73,1h-50.96Zm17.85,50.65h-9.25l12.28-22.13-3.03,22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,1h-50.28l-10.69,12.85-16.61,48.35,2.73,14.56h47.89l12.51-13.54,16.95-49.37-2.5-12.85Zm-35.21,49.43l-3,3.24h-9.34l-.85-4.74,8.86-24.08,3.19-3.83h9.23l.92,4.7-9,24.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,13.85l-2.5-12.85h-62.91l-6.83,19.91h6.37l-19.22,55.85h27.07l6.49-18.96,2.16,18.96h27.76l7.85-22.98h-9.21l14.11-13.99,8.87-25.94Zm-30.56,15.11l-2.85,2.83h-11.08l4.45-13.17h10.46l.04,.05,.89,4.59-1.91,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.83,13.85l-2.5-12.85h-62.91l-6.83,19.91h6.37l-19.22,55.85h27.07l7.85-22.98h27.98l13.31-13.99,8.87-25.94Zm-29.94,14.83l-2.96,3.11h-11.07l4.45-13.17h10.47l.91,4.69-1.8,5.37Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "70.01 16.03 98.11 16.03 99.38 13.86 71.25 13.86 70.01 16.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "90.18 29.46 91.79 26.72 63.86 26.72 62.28 29.46 90.18 29.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "86.15 36.29 88.03 33.1 60.19 33.1 58.36 36.29 86.15 36.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "94.14 22.74 95.62 20.24 67.59 20.24 66.15 22.74 94.14 22.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "58.94 7.38 30.71 7.38 30.54 9.2 58.74 9.2 58.94 7.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "106.1 2.48 106.97 1 78.65 1 77.8 2.48 106.1 2.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "84.27 39.47 56.53 39.47 55.1 41.95 55.37 39.47 27.63 39.47 27.29 43 82.19 43 84.27 39.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "31.32 1 31.18 2.48 59.49 2.48 59.65 1 31.32 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "102.14 9.2 103.21 7.38 74.98 7.38 73.93 9.2 102.14 9.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "72.85 58.82 25.77 58.82 25.34 63.26 70.23 63.26 72.85 58.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "80.44 45.96 27 45.96 26.64 49.72 78.23 49.72 80.44 45.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "76.68 52.33 26.39 52.33 25.99 56.55 74.2 56.55 76.68 52.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "69.09 65.2 25.15 65.2 24.69 69.98 66.27 69.98 69.09 65.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "65.26 71.68 24.53 71.68 24.04 76.76 62.27 76.76 65.26 71.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "56.08 33.1 28.24 33.1 27.93 36.29 55.73 36.29 56.08 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "57.51 20.24 29.47 20.24 29.23 22.74 57.23 22.74 57.51 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "58.22 13.86 30.09 13.86 29.88 16.03 57.98 16.03 58.22 13.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "56.79 26.72 28.85 26.72 28.59 29.46 56.49 29.46 56.79 26.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "320.48 52.33 319.03 56.55 382.46 56.55 383.4 53.79 374.19 53.79 375.65 52.33 320.48 52.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "324.91 39.47 323.7 43 385.06 43 388.29 39.79 388.4 39.47 324.91 39.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "329.3 26.72 328.36 29.46 353.47 29.46 354.39 26.72 329.3 26.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "347.22 71.68 347.8 76.76 375.55 76.76 377.29 71.68 347.22 71.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "325.16 20.24 324.93 20.91 331.3 20.91 330.67 22.74 355.74 22.74 356.58 20.24 325.16 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "367.93 20.24 368.42 22.74 394.13 22.74 394.98 20.24 367.93 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "329.57 7.38 328.95 9.2 396.26 9.2 395.91 7.38 329.57 7.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "331.76 1 331.25 2.48 394.95 2.48 394.66 1 331.76 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "327.1 33.1 326.01 36.29 389.49 36.29 390.58 33.1 327.1 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "345.75 58.82 346.26 63.26 380.16 63.26 381.68 58.82 345.75 58.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "322.68 45.96 321.38 49.72 378.29 49.72 382.07 45.96 322.68 45.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "346.48 65.2 347.02 69.98 377.87 69.98 379.5 65.2 346.48 65.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "367.36 26.72 366.61 28.97 366.11 29.46 391.83 29.46 392.76 26.72 367.36 26.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "327.35 13.86 326.6 16.03 396.42 16.03 397.16 13.86 327.35 13.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "340.89 71.68 313.82 71.68 312.08 76.76 339.15 76.76 340.89 71.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "316.06 65.2 314.41 69.98 341.47 69.98 343.11 65.2 316.06 65.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "318.25 58.82 316.72 63.26 343.77 63.26 345.29 58.82 318.25 58.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "268.91 48.93 270 45.96 245.31 45.96 244.02 49.72 269.05 49.72 268.91 48.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "247.53 39.47 246.32 43 271.09 43 272.39 39.47 247.53 39.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "249.72 33.1 248.63 36.29 273.56 36.29 274.73 33.1 249.72 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "251.91 26.72 250.98 29.46 276.08 29.46 277.08 26.72 251.91 26.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "301.04 65.2 240.29 65.2 241.18 69.98 296.62 69.98 301.04 65.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "261.73 7.38 260.21 9.2 318.9 9.2 318.55 7.38 261.73 7.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "267.03 1 265.8 2.48 317.6 2.48 317.31 1 267.03 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "256.33 13.86 255.59 16.03 319.07 16.03 319.81 13.86 256.33 13.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "288.41 33.1 287.25 36.29 312.11 36.29 313.2 33.1 288.41 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "253.28 22.74 279.52 22.74 280.95 21.02 290.19 21.02 290.52 22.74 316.76 22.74 317.62 20.24 254.14 20.24 253.28 22.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "290.74 26.72 289.74 29.46 314.46 29.46 315.39 26.72 290.74 26.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "286.09 39.47 284.81 43 309.81 43 311.02 39.47 286.09 39.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "239.73 62.2 239.92 63.26 302.83 63.26 302.86 63.23 304.37 58.82 240.89 58.82 239.73 62.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "280.34 52.33 279.1 53.67 269.76 53.67 269.52 52.33 243.12 52.33 241.67 56.55 305.16 56.55 306.6 52.33 280.34 52.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "290.35 76.76 295.04 71.68 241.5 71.68 242.46 76.76 290.35 76.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "283.73 45.96 282.36 49.72 307.5 49.72 308.79 45.96 283.73 45.96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "169.91 58.82 168.38 63.26 195.42 63.26 196.94 58.82 169.91 58.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "179.01 13.86 178.26 16.03 248.08 16.03 248.82 13.86 179.01 13.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "220.09 20.24 220.58 22.74 245.79 22.74 246.64 20.24 220.09 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "218.89 28.69 218.16 29.46 243.49 29.46 244.42 26.72 219.55 26.72 218.89 28.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "181.23 7.38 180.61 9.2 247.92 9.2 247.57 7.38 181.23 7.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "174.34 45.96 173.04 49.72 230.51 49.72 234.08 45.96 174.34 45.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "183.42 1 182.91 2.48 246.61 2.48 246.32 1 183.42 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "172.14 52.33 170.69 56.55 197.72 56.55 198.66 53.79 226.64 53.79 228.02 52.33 172.14 52.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "166.07 69.98 193.13 69.98 194.76 65.2 167.72 65.2 166.07 69.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "178.76 33.1 177.67 36.29 241.15 36.29 242.24 33.1 178.76 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "180.96 26.72 180.02 29.46 205.65 29.46 206.58 26.72 180.96 26.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "176.82 20.24 176.59 20.91 182.96 20.91 182.33 22.74 207.92 22.74 208.77 20.24 176.82 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "176.57 39.47 175.36 43 236.9 43 239.95 39.79 240.06 39.47 176.57 39.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "192.54 71.68 165.48 71.68 163.74 76.76 190.81 76.76 192.54 71.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "157.66 63.26 158.09 58.82 89.81 58.82 87.19 63.26 157.66 63.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "158.32 56.55 158.73 52.33 93.64 52.33 91.16 56.55 158.32 56.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "110.59 7.38 109.96 9.2 162.94 9.2 163.11 7.38 110.59 7.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "157.01 69.98 157.47 65.2 86.05 65.2 83.22 69.98 111.88 69.98 111.91 69.94 127.79 69.94 127.79 69.98 157.01 69.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "112.21 20.91 111.12 22.74 161.61 22.74 161.86 20.24 106.27 20.24 112.21 20.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "112.77 1 112.27 2.48 163.59 2.48 163.74 1 112.77 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "162.27 16.03 162.48 13.86 108.36 13.86 107.62 16.03 162.27 16.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "156.84 71.68 127.79 71.68 127.79 76.76 156.34 76.76 156.84 71.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "110.82 71.68 82.21 71.68 79.21 76.76 107.65 76.76 110.82 71.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "101.24 39.47 99.16 43 126.18 43 128.14 39.47 101.24 39.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "158.98 49.72 159.35 45.96 131.41 45.96 130.89 49.72 158.98 49.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "97.41 45.96 95.19 49.72 122.46 49.72 124.54 45.96 97.41 45.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "105 33.1 103.12 36.29 129.91 36.29 131.68 33.1 105 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "159.64 43 159.98 39.47 132.3 39.47 131.81 43 159.64 43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "132.73 36.29 160.29 36.29 160.6 33.1 133.17 33.1 132.73 36.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "108.77 26.72 107.16 29.46 160.96 29.46 161.23 26.72 108.77 26.72"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.84,77.76H22.94L30.41,0h30.35l-4.14,37.3L78.07,0h30.66L62.84,77.76Zm-37.69-2H61.69L105.22,2h-26l-25.65,44.61L58.53,2h-26.3l-7.09,73.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,77.76h-30.46v-6.82h-14.33l-4.25,6.82h-30.75L110.56,21.73l-5.73-.65L112.06,0h52.78l-7.59,77.76Zm-28.46-2h26.65L162.63,2h-49.15l-5.96,17.37,6.33,.72-32.88,55.67h26.13l4.25-6.82h17.44v6.82Zm2.71-23.11h-11.82l15.69-28.28-3.87,28.28Zm-8.42-2h6.68l2.19-15.98-8.86,15.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78,77.76h-49.16l-2.93-15.64,16.76-48.77,11.11-13.36h51.57l2.71,13.93-17.1,49.82-12.95,14.01Zm-47.5-2h46.62l12.07-13.06,16.79-48.92-2.29-11.78h-48.99l-10.28,12.35-16.46,47.92,2.53,13.48Zm36.25-21.09h-10.62l-1.04-5.83,9.01-24.5,3.6-4.32h10.52l1.13,5.79-9.17,25.15-3.43,3.71Zm-8.94-2h8.07l2.56-2.77,8.84-24.25-.71-3.62h-7.94l-2.78,3.34-8.7,23.66,.65,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,77.76h-29.36l-1.76-15.43-5.28,15.43h-29.19l19.22-55.85h-6.37l7.51-21.91h64.45l2.71,13.93-9.04,26.41-12.55,12.45h8.18l-8.53,24.98Zm-27.58-2h26.15l7.17-20.98h-10.24l15.66-15.54,8.71-25.46-2.29-11.78h-61.37l-6.14,17.91h6.37l-19.22,55.85h24.96l7.69-22.48,2.56,22.48Zm15.48-42.96h-12.88l5.12-15.17h11.7l.42,.6,.08,.26,.94,4.85-2.07,6.17-3.31,3.29Zm-10.1-2h9.27l2.39-2.37,1.75-5.22-.7-3.57h-8.95l-3.77,11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,77.76h-29.19l19.22-55.85h-6.37L182.7,0h64.45l2.71,13.93-9.03,26.4-13.76,14.46h-27.7l-7.85,22.98Zm-26.39-2h24.96l7.85-22.98h28.27l12.86-13.52,8.72-25.48-2.29-11.78h-61.37l-6.14,17.91h6.37l-19.22,55.85Zm51.22-42.96h-12.89l5.12-15.17h11.8l.36,.81,.96,4.95-1.96,5.83-3.41,3.58Zm-10.1-2h9.24l2.51-2.64,1.65-4.91-.71-3.62h-8.92l-3.77,11.17Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsLogoLightRed);
export default __webpack_public_path__ + "static/media/vs_logo_light_red.e95de332f65fc01b1c3f7a3c7ce14517.svg";
export { ForwardRef as ReactComponent };